// Владелец не всегда приходит в getTeams, но в лимит команды входит.
// Считаем уникальных по _id, чтобы не задвоить, если сервер его всё же вернёт.
export function countTeamMembers(teams, ownerID) {
  const ids = new Set();
  (teams || []).forEach((member) => {
    if (member && member._id) ids.add(member._id);
  });
  if (ownerID) ids.add(ownerID);
  return ids.size;
}
